import { createAction, ActionsUnion } from "../definitions";
import { UserActionTypes } from "./types";

export const actions = {
    clearUsers: () => createAction(UserActionTypes.CLEAR_USERS),
    setUsers: (payload: IIdDictionary<IUser>) => createAction(UserActionTypes.SET_USERS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare, @typescript-eslint/naming-convention
export type actions = ActionsUnion<typeof actions>;